import React from 'react'
import FormHeader from './FormHeader'
import CandidatesForm from './CandidatesForm'
import TopHeaderForm from './TopHeaderForm'
import './candidate.css'
import { Toaster } from 'react-hot-toast'
const Candidate = () => {
  return (
    <>
      <FormHeader/>
      <CandidatesForm/>
      <TopHeaderForm/>
      <Toaster position="top-right" />
    </>
  )
}

export default Candidate